<template>
  <div class="access">
    <!-- 头部 -->
    <div class="header">
      <div class="left">
        <img src="../assets/logo3.png" />
        <div>四川卓远企业征信咨询有限公司</div>
      </div>
      <div class="right">
        <el-dropdown @command="handleCommand">
          <div class="info">
            <img size="small" src="../assets/user11.png" />
            <div class="name">{{ name }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="myWarranty">我的</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <el-card class="search-card">
      <el-form :inline="true" :model="searchParams" ref="searchFormRef">
        <el-form-item label="项目名称" prop="projectName">
          <el-input
            v-model="searchParams.projectName"
            placeholder="请输入项目名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="querySubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 项目选择 -->
    <div class="box-title">
      <div class="wire"></div>
      <div class="title">项目选择</div>
    </div>

    <el-card class="insurance" v-for="item in insuranceList" :key="item.id">
      <div class="insurance-title">
        <img src="../assets/logo1.png" />
        <div class="insurance-box">
          <div class="title">{{ item.projectName }}</div>
          <div class="serial">项目编号：{{ item.projectNo }}</div>
          <div class="section">
            <div class="name">标段名称：{{ item.lotName }}</div>
            <div>标段编号：{{ item.lotNo }}</div>
          </div>
          <div class="section">
            <div class="name">保证金金额(元)：{{ item.bondAmount }}</div>
            <div>项目金额(元)：{{ item.projectAmount }}</div>
          </div>
          <div class="btn">
            <el-button type="primary" size="mini" @click="handleDetails(item)"
              >查看详情</el-button
            >
          </div>
        </div>
      </div>
    </el-card>
    <div class="footer">
      <Pagination
        ref="pagination"
        :propCurrentPage="page"
        :propPageSize="pageSize"
        :callback="getInsuranceList"
        :total="total"
      >
        >
      </Pagination>
    </div>

    <!-- tabs选择 -->
    <div class="tabs">
      <div class="tabs-box" @click="handleToUrl">
        <div class="title">
          <div>我的</div>
          <img src="../assets/user.png" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
export default {
  name: "Access",
  components: { Pagination },
  data() {
    return {
      insuranceList: [],
      total: 0,
      page: 1,
      pageSize: 10,
      searchParams: {},
      name: window.sessionStorage.getItem("enterpriseName")
    };
  },
  mounted() {
    this.getInsuranceList();
  },
  methods: {
    handleToUrl() {
      this.$router.push("/my")
    },
    // 重置搜索框
    resetForm() {
      this.$refs.searchFormRef.resetFields();
      this.getInsuranceList();
    },
    // 点击头像 退出登录
    handleCommand(command) {
      if (command === "logout") {
        this.logout();
      }
      if (command === "myWarranty") {
        this.myWarranty();
      }
    },
    // 我的
    myWarranty() {
      this.$router.push("/my");
    },
    // 退出登录
    logout() {
      window.sessionStorage.clear();
      this.$router.push("/");
    },

    // 项目列表
    async getInsuranceList(searchVal, page = 1, pageSize = 10) {
      const { data: res } = await this.$http.post(
        `Insurance/information/list1?status=0&pageNum=${page}&pageSize=${pageSize}&projectName=${
          searchVal != undefined ? searchVal.projectName : " "
        }`
      );
      if (res.code === 200) {
        this.insuranceList = res.rows;
        this.total = res.total;
      }
    },
    // 查询项目列表
    querySubmit() {
      this.getInsuranceList(this.searchParams);
    },
    // 跳转详情页
    handleDetails(row) {
      this.$router.push({
        path: "./home",
      });
      window.sessionStorage.setItem("row", JSON.stringify(row));
    },
  },
};
</script>

<style lang="scss">
.access {
  width: 100%;
  position: relative;

  .tabs {
    position: fixed;
    top: 50%;
    right: 20px;
    width: 80px;
    height: 100px;
    background: #fff;
    border-radius: 5px;
    text-align: center;
    -webkit-box-shadow: 3px 6px 16px rgb(0 0 0 / 20%);
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
    .tabs-box {
      .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100px;
        cursor: pointer;
        border-bottom: 1px solid #f1f1f1;
        &.active {
          background: #f1f1f1;
        }
      }

      img {
        width: 30px;
        height: 30px;
        margin-top: 9px;
      }
    }
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    height: 80px;
    margin: 0 auto 20px;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 50px;
        height: 40px;
        margin-right: 5px;
      }
      div {
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
      }
    }
    .right {
      display: flex;
      align-items: center;
      .info {
        display: flex;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
        }
        .name {
          margin-left: 10px;
        }
      }
    }
  }

  .border-card {
    width: 1200px;
    margin: 0 auto 10px;
    .el-tabs__item {
      font-size: 20px;
    }
  }

  .search-card {
    width: 1200px;
    height: 80px;
    margin: 0 auto 10px;
  }
  .box-title {
    display: flex;
    align-items: center;
    width: 1200px;
    height: 40px;
    margin: 0 auto 10px;
    .wire {
      width: 4px;
      height: 25px;
      background: #3f74dc;
    }
    .title {
      margin-left: 10px;
      font-size: 18px;
    }
  }
  .insurance {
    width: 1200px;
    height: 200px;
    margin: 0 auto 20px;
    .insurance-title {
      display: flex;
      width: 100%;
      height: 60px;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
      .insurance-box {
        width: 100%;
        height: 100%;
        .title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 5px;
        }
        .serial {
          color: #999;
          margin-bottom: 20px;
        }
        .section {
          display: flex;
          align-items: center;
          color: #999;
          margin-bottom: 10px;
          .name {
            margin-right: 20px;
          }
        }
        .btn {
          display: flex;
          justify-content: end;
        }
      }
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: end;
    width: 1200px;
    height: 100px;
    margin: 0 auto;
  }
}
</style>